<template>
  <div
    :class="['quiz', {'quiz__final': final}]"
  >
    <div class="quiz_header" v-if="!final">
      <h2 class="quiz_heading">Викторина</h2>
      <h1 class="heading1">
        <span>{{ $c('Задание') }} {{ this.currentQuizIndex + 1 }} <span class="quiz_grey">/ {{ this.quizSetup.length }}</span></span>
        <br />
        <span>{{ quizTask }}</span>
      </h1>
    </div>
    <TransitionGroup
      name="page-transition"
      mode="out-in"
      appear
    >
      <div
        class="quiz_template-place"
        v-bind:is="currentQuiz"
        :quiz-data="currentQuizData"
        :last-quest="lastQuest"
        :result-message="resultMessage"
        v-show="!loading"
        v-bind:key="'quiz_template-place'"
      />
      <Final
        v-show="!loading && final"
        v-bind:key="'quiz_template-finish'"
        :correct-counter="correctCounter"
        :total="this.quizSetup.length"
      />
      <div
        v-show="loading"
        class="quiz_template-place quiz_template-place__loading"
        v-bind:key="'quiz_template-place__loading'"
      >
        <Spinner size="medium" color="red"  />
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import Spinner from '@/common/components/Spinner.vue'
import QuizTemplate1 from './QuizTemplate1'
import QuizTemplate2 from './QuizTemplate2'
import QuizTemplate3 from './QuizTemplate3'
import Final from './Final'

import { namespace } from 'vuex-class'
const randomRewards = namespace('randomRewards')

@Component({
  components: {
    Spinner,
    QuizTemplate1,
    QuizTemplate2,
    QuizTemplate3,
    Final
  }
})
class Quiz extends Vue {
  @randomRewards.State('quizSetup') quizSetup
  @randomRewards.Action('postQuiz') postQuiz
  loading = true
  final = false
  lastQuest = false
  currentQuizIndex = 0
  correctCounter = 0
  templateIndexToTemplate = {
    1: QuizTemplate1,
    2: QuizTemplate2,
    3: QuizTemplate3
  }

  get currentQuiz () {
    if (this.final) return null
    const templateIndex = this.quizSetup[this.currentQuizIndex].template
    return this.templateIndexToTemplate[templateIndex]
  }

  get quizTask () {
    return this.quizSetup[this.currentQuizIndex].task
  }

  get currentQuizData () {
    return this.quizSetup[this.currentQuizIndex].quizData
  }

  get resultMessage () {
    return this.quizSetup[this.currentQuizIndex].resultMessage
  }

  created () {
    this.$root.$on('quizNextQuest', this.onNextQuest)
  }

  destroyed () {
    this.$root.$off('quizNextQuest', this.onNextQuest)
  }

  mounted () {
    this.stratLoadingTime()
  }

  onNextQuest (correct) {
    if (correct) {
      this.correctCounter++
    }
    this.loading = true
    setTimeout(() => {
      if (this.quizSetup.length === this.currentQuizIndex + 2) {
        this.lastQuest = true
      }
      if (this.quizSetup.length === this.currentQuizIndex + 1) {
        this.postQuiz()
        this.final = true
      } else {
        this.currentQuizIndex++
      }
    }, 300)
    this.stratLoadingTime()
  }

  stratLoadingTime () {
    setTimeout(() => {
      this.loading = false
    }, 800)
  }
}
export default Quiz
</script>

<style lang="scss">
  .quiz {
    display: grid;
    padding: 30px;
    box-sizing: border-box;
    @include media_tablet {
      padding: 40px 60px;
      height: 100%;
      grid-template-rows: max-content 1fr;
    }
    &__final {
      padding: 40px 0;
      height: 100%;
      align-items: center;
    }
    &_header {
      display: block;
      padding-top: 30px;
    }
    &_heading {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 25px;
      color: #666666;
      margin-bottom: 10px;
    }
    &_template-place {
      display: block;
      margin-top: 30px;
      min-height: 50vh;
      transition: min-height .3s ease;
      @include media_tablet {
        height: 100%;
      }
      &__loading {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: calc(100% - 110px);
      }
    }
    &_grey {
      color: #666666;
    }
  }
</style>
